import React from 'react';
import { Avatar } from '@mui/material';

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  /* eslint-enable no-bitwise */

  const hue = Math.abs(hash % 360);
  return `hsl(${hue}, 50%, 65%)`;
}

function stringAvatar(name) {
    if (!name) return {};
    
    // Split name and take up to first two parts for initials
    const nameParts = name.trim().split(/\s+/);
    let children = '';
    
    if (nameParts.length >= 2) {
        children = `${nameParts[0][0]}${nameParts[1][0]}`;
    } else if (nameParts.length === 1 && nameParts[0].length > 0) {
        children = `${nameParts[0][0]}`;
    }

  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: children.toUpperCase(),
  };
}

const UserAvatar = ({ src, name, sx = {}, ...props }) => {
  const stringProps = name ? stringAvatar(name) : {};
  
  // Merge sx from stringProps and passed sx. Passed sx takes precedence if overlapping keys, 
  // but we usually want the dynamic bgcolor if src is missing/failing.
  // Actually, allow user to override bgcolor if they really want to.
  const combinedSx = {
      ...stringProps.sx,
      ...sx
  };

  return (
    <Avatar
      {...stringProps}
      {...props}
      src={src}
      sx={combinedSx}
      alt={name || props.alt}
    />
  );
};

export default UserAvatar;
